/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Need_RuianInputs */

const cs_property_registry_need_ruian = /** @type {(inputs: Property_Registry_Need_RuianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro načtení katastru nastavte u nemovitosti adresu z RÚIAN.`)
};

const en_property_registry_need_ruian = /** @type {(inputs: Property_Registry_Need_RuianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a RÚIAN address on the property to load cadastre data.`)
};

/**
* | output |
* | --- |
* | "Set a RÚIAN address on the property to load cadastre data." |
*
* @param {Property_Registry_Need_RuianInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_need_ruian = /** @type {((inputs?: Property_Registry_Need_RuianInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Need_RuianInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_need_ruian(inputs)
	return cs_property_registry_need_ruian(inputs)
});